import type { ReactNode } from 'react';
import { Box, Button } from '@mantine/core';
import { createPortal } from 'react-dom';

export const MobileFab = ({ onClick, children }: { onClick: () => void; children: ReactNode }) => (
  <>
    <span className="mobile-fab-anchor" hidden />
    {createPortal(
      <Box
        hiddenFrom="sm"
        className="mobile-fab"
        style={{
          position: 'fixed',
          right: 16,
          bottom: 'calc(16px + env(safe-area-inset-bottom))',
          zIndex: 90,
          transform: 'translateZ(0)'
        }}
      >
        <Button
          onClick={onClick}
          radius="xl"
          style={{ boxShadow: '0 6px 16px rgba(15, 23, 42, 0.22)' }}
        >
          {children}
        </Button>
      </Box>,
      document.body
    )}
  </>
);
